const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20portrait%20avatar%20illustration%20of%20a%20young%20woman%20with%20warm%20smile%2C%20flat%20art%20style%2C%20soft%20cream%20background%2C%20clean%20simple%20design%2C%20manga%20reader%20persona%2C%20gentle%20warm%20tones&width=120&height=120&seq=avatar-01-2026&orientation=squarish',
    name: '星野琉璃',
    time: '2小时前',
    content: '女神漫画网的追更提醒真的太及时了！《星光深处的你》刚更新我就收到了推送，下拉式阅读体验超级丝滑，已经安利给身边所有追漫的朋友啦。',
    manga: '追《星光深处的你》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20portrait%20avatar%20illustration%20of%20a%20young%20man%20with%20gentle%20expression%2C%20flat%20art%20style%2C%20soft%20cream%20background%2C%20clean%20simple%20design%2C%20manga%20enthusiast%20persona%2C%20warm%20neutral%20tones&width=120&height=120&seq=avatar-02-2026&orientation=squarish',
    name: '墨染清风',
    time: '5小时前',
    content: '作为一个追了十几年日漫的老读者，女神漫画网的韩漫日漫国漫全覆盖真的让我省了不少心。不用在各个平台间来回切换，一个网站搞定所有追更需求。',
    manga: '追《深渊游戏》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20portrait%20avatar%20illustration%20of%20a%20young%20woman%20glasses%2C%20flat%20art%20style%2C%20soft%20cream%20background%2C%20clean%20simple%20design%2C%20book%20lover%20persona%2C%20warm%20gentle%20tones&width=120&height=120&seq=avatar-03-2026&orientation=squarish',
    name: '樱落无声',
    time: '1天前',
    content: '免费全集真的太香了！之前在其他平台追更经常遇到收费章节，女神漫画网免费全集持续更新，而且画面清晰度很高，下拉式追更体验十分舒适。',
    manga: '追《蔷薇之约》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者热议
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            听听追更伙伴们怎么说，一起加入女神漫画网追更社群
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-50 text-primary-700">
                {item.manga}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}